import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import * as MuiIcons from "@mui/icons-material";
import {Box, Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow} from "@mui/material";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import TableHeader from "../../layout/table/TableHeader.js";
import NoDataLabel from "../../layout/NoDataLabel.js";
import ModalDelete from "../../layout/ModalDelete.js";
import Constants from "../../../../utils/constants.js";
import {getPicto} from "../../../../utils/pictoCatalog.js";

function Picto({pictoKey, color}) {
    const entry = getPicto(pictoKey);
    const Cmp = MuiIcons[entry.mui] || MuiIcons.Help;
    return <Cmp sx={{color: color || "inherit"}}/>;
}

const headCells = [
    {id: "picto", label: "Icône"},
    {id: "code", label: "Code"},
    {id: "libelleFr", label: "Libellé (FR)"},
    {id: "libelleAr", label: "Libellé (AR)"},
];

export default function ConsigneTable({consignes = [], onDelete}) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [current, setCurrent] = useState(null);

    const handleEditClick = (id) => navigate(Constants.APP_ROUTE_ADMIN_CONSIGNES_EDIT.replace(":id", id));

    const openDeleteConfirmModal = (c) => {
        setCurrent(c);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCurrent(null);
    };

    const handleDelete = () => {
        onDelete(current);
        handleClose();
    };

    return (
        <>
            <TableContainer component={Paper} className={"mt-2"}>
                <Table aria-label="consignes table" size="small">
                    <TableHeader headCells={headCells}/>
                    <TableBody>
                        {consignes.length === 0 &&
                            <TableRow>
                                <TableCell colSpan={5} align={"center"}>
                                    <NoDataLabel label={"Il n'y a encore aucune consigne enregistrée"}/>
                                </TableCell>
                            </TableRow>
                        }
                        {consignes.map((c) => (
                            <TableRow key={c.id} hover style={{cursor: "pointer"}} onClick={() => handleEditClick(c.id)}>
                                <TableCell>
                                    <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                                        <Picto pictoKey={c.picto} color={c.couleur}/>
                                        <Box sx={{width: 16, height: 16, borderRadius: "50%", bgcolor: c.couleur || "transparent", border: "1px solid #ddd"}}/>
                                    </Box>
                                </TableCell>
                                <TableCell>{c.code}</TableCell>
                                <TableCell>{c.libelleFr}</TableCell>
                                <TableCell dir="rtl">{c.libelleAr}</TableCell>
                                <TableCell>
                                    <Stack direction={"row"} spacing={2} justifyContent={"end"}>
                                        <Button color="secondary" size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleEditClick(c.id);
                                                }}
                                                startIcon={<ModeEditOutlineOutlinedIcon/>}>
                                            Éditer
                                        </Button>
                                        <Button color="error" size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openDeleteConfirmModal(c);
                                                }}
                                                startIcon={<CloseOutlinedIcon/>}>
                                            Supprimer
                                        </Button>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <ModalDelete
                label={"Êtes-vous sûr de vouloir supprimer la consigne : "}
                onClose={handleClose}
                open={open}
                objectToDelete={current?.libelleFr}
                selectedValue={current}
                onDelete={handleDelete}
            />
        </>
    );
}
